import React, {Component} from 'react'
import {Image, Button, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import Dropzone from './Dropzone'
import showToastr from '../../../utils/showToastr'
import {MdAddAPhoto, MdClear} from '../../Common/ReactIcons/icons'

class Uploader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      src: '',
      showImage: true,
      progress: false,
      request: null,
      showHelp: true,
      isEmpty: true
    }
    this.startUpload = this.startUpload.bind(this)
    this.loading = this.loading.bind(this)
    this.cancelUpload = this.cancelUpload.bind(this)
    this.requestSetter = this.requestSetter.bind(this)
    this.pickSelectedFile = this.pickSelectedFile.bind(this)
    this.reset = this.reset.bind(this)
  }

  requestSetter (r) {
    this.setState({request: r})
  }

  cancelUpload () {
    if (this.state.progress) {
      this.state.request.cancel()
    }
  }

  reset () {
    this.setState({src: '', isEmpty: true})
  }

  loading (progressEvent) {
    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    this.setState({progress: percentCompleted})
  }

  pickSelectedFile (event) {
    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }

    const reader = new window.FileReader()
    reader.onload = () => {
      this.setState({ src: reader.result, isEmpty: false })
    }
    reader.readAsDataURL(files[0])
  }

  startUpload (uploadForm, horseId = null) {
    if (this.state.isEmpty) {
      showToastr('warning', 'ثبت اسب جدید', 'فایلی برای آپلود انتخاب نشده است')
      return undefined
    }

    let data = new window.FormData()
    data.append('file', document.getElementById('file').files[0])
    data.append('title', uploadForm.title)
    data.append('description', uploadForm.description)
    data.append('title_fa', uploadForm.title_fa)
    data.append('description_fa', uploadForm.description_fa)

    this.setState({progress: 0})

    if (horseId) {
      data.append('horse_id', horseId)

      return Actions.uploadHorsePhoto({
        data: data,
        progress: this.loading,
        requestSetter: this.requestSetter
      }).then((res) => {
        this.setState({isEmpty: true, progress: false})
        showToastr('success', 'ثبت تصویر جدید', res.data.messages[0])
        return res
      }).catch((error) => {
        this.setState({isEmpty: true, progress: false})
        showToastr('error', 'ثبت تصویر جدید', error)
      })
    } else {
      return Actions.uploadNewPhoto({
        data: data,
        progress: this.loading,
        requestSetter: this.requestSetter
      }).then((res) => {
        this.setState({isEmpty: true, progress: false})
        showToastr('success', 'ثبت اسب جدید', res.data.messages[0])
        return res
      }).catch((error) => {
        this.setState({isEmpty: true, progress: false})
        showToastr('error', 'ثبت اسب جدید', error)
      })
    }
  }

  render () {
    const {progress, isEmpty} = this.state
    const tooltipCancel = (
      <Tooltip id="tooltip">لغو آپلود</Tooltip>
    )
    const preview = (
      <Image src={this.state.src} onClick={() => document.getElementById('file').click()} />
    )
    return (
      <div>
        {!isEmpty && preview}
        <Dropzone pickFiles={this.pickSelectedFile}>
          <div className="dropzone-controller">
            {isEmpty && <span className="doorbin"><MdAddAPhoto /></span>}
            {isEmpty && <div>عکس اسب مورد نظر را اینجا بکشید و رها کنید</div>}
            {isEmpty && <Button onClick={() => document.getElementById('file').click()}>انتخاب فایل</Button>}
            {progress && <div className="progress-bar-shadow" style={{height: 312 - (312 * progress / 100)}} />}
            <br />
            {(!isEmpty && !progress) && <Button bsStyle="danger" bsSize="small" onClick={this.reset} className="cancel-upload"><MdClear /></Button>}
            {progress && <OverlayTrigger placement="right" overlay={tooltipCancel}>
              <Button bsStyle="danger" bsSize="small" onClick={this.cancelUpload} className="cancel-upload"><MdClear /></Button>
            </OverlayTrigger>}
            <input id="file" name="file" type="file" className="hide" onChange={this.pickSelectedFile} />
          </div>
        </Dropzone>
      </div>
    )
  }
}

export default Uploader



// WEBPACK FOOTER //
// ./src/components/NewHorse/Uploader/Uploader.js